import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {sortByLabelFunc} from '@catcore/utils';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {FeatureAvodCatalogService} from '@catmodels/avod-catalog/services/feature-avod-catalog.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'cat-feature-avod-catalog-create',
  templateUrl: './feature-avod-catalog-create.component.html',
  styleUrls: ['./feature-avod-catalog-create.component.scss'],
})
export class FeatureAvodCatalogCreateComponent extends BaseFeatureWelcomeComponent {
  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfLabel = 'Feature AVoD Catalog';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfLabel}`;
  resetAfterComplete = true;

  // selection values
  avodCatalogServiceOptions: SelectItem[];
  modeOptions: SelectItem[];

  labels = {
    name: 'Name',
    avodCatalogService: 'AVoD Catalog Service',
    mode: 'Mode',
    rootPath: 'Root Path',
    removableMedia: 'Removable Media',
    trackRemoves: 'Track Removes',
    buttons: {last: `Save the ${this.selfLabel}`},
  };

  private featureSchema = null;

  // default values
  private throttle = 'idle';
  private locationId = 0;
  private lowWaterMark = 30;
  private triggerFile = null;
  private baseURL = '';
  private additionalPaths = '';


  get formIsReady() {
    let isReady = !isNullOrUndefined(this.feature);
    isReady = isReady && !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.featureSchema);
    return isReady;
  }

  constructor(private featureAvodCatalogService: FeatureAvodCatalogService,
              featureService: FeatureTypeService,
              private schemaService: EntitySchemaService) {
    super(featureService);

    this.featureSchema = schemaService.getForEntityName(EntitySchemaType['FeatureAvodCatalogs']);
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      avodCatalogService: new FormControl(null, [Validators.required]),
      mode: new FormControl(null, [Validators.required]),
      rootPath: new FormControl('', [Validators.required]),
      removableMedia: new FormControl(false, []),
      trackRemoves: new FormControl(false, []),
    });
  }

  beforeDisplayProperties() {
    this.getFeatureService()
      .getServices(this.feature.id.toString()).subscribe((services: any[]) => {
        this.updateAvodCatalogServiceOptions(services);
    });

    if (this.featureSchema) {
      this.modeOptions = this.updateChoicesOptions(this.featureSchema.properties.mode.choices);
    }
  }

  saveNewEntity() {
    this.featureAvodCatalogService
      .create({
        name: this.form.value.name,
        service: this.form.value.avodCatalogService,
        mode: this.form.value.mode,
        throttle: this.throttle,
        locationId: this.locationId,
        lowWaterMark: this.lowWaterMark,
        triggerFile: this.triggerFile,
        baseURL: this.baseURL,
        rootPath: this.form.value.rootPath,
        additionalPaths: this.additionalPaths,
        removableMedia: this.form.value.removableMedia,
        trackRemoves: this.form.value.trackRemoves,
        feature: this.feature._links.self.href,
      })
      .subscribe((featureService) => {
        this.setCurrentEntity(featureService);
        this.setIsCompleted(featureService !== null);
        this.getFeatureService().refreshCurrent();
      });
  }

  modeChanged($event) {
    if ((this.form.value.mode === 'tracker') && !this.form.value.removableMedia ) {
      this.form.patchValue({rootPath: '/mnt/private_media'});
      this.triggerFile = '.metainfo.dat';
    } else if (this.form.value.mode === 'mpu') {
      this.form.patchValue({
        root_path: '/mnt/protected_media',
        removable_media: false,
      });
      this.triggerFile = 'mpu.xml';
    }
  }

  removableMediaChanged($event) {
    if (this.form.value.removableMedia) {
        this.form.patchValue({rootPath: '/mnt/usb'});
        this.triggerFile = '.metainfo.dat';
    } else {
      this.modeChanged(null);
    }
  }

  validatePropertiesView() {
  }

  getServiceName(service: any): string {
    return service.name + '@' + service._links.unit_type.label;
  }

  private updateOptionsList(items: any[]) {
    const optionList = [];
    items.forEach((item) => {
      optionList.push({label: item.name + '@' + item._links.unit_type.label, value: item});
    });
    optionList.sort(sortByLabelFunc);
    return optionList;
  }

  private updateAvodCatalogServiceOptions(items: any[]) {
    const services = items.filter( (service) => {
        return service['name'] === 'AVODCatalog';
    });
    this.avodCatalogServiceOptions = this.updateOptionsList(services);
  }

  /**
   * Update the available GUI zone types
   *
   * @param {string[]} choices
   */
  private updateChoicesOptions(choices: string[]) {
    const items: SelectItem[] = [];
    choices.forEach((name: string) => items.push({label: name, value: name}));
    return items;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/feature-avod-catalog-create/feature-avod-catalog-create.component.ts